// extracted by mini-css-extract-plugin
module.exports = {"DevPortal":"DevPortal_DevPortal__3L7cI"};